import React from "react";
import { Route, Switch } from 'react-router-dom';
import asyncComponent from '../../../itrust_common/components/AsyncComponent';

const GroupsWrapper = asyncComponent(() =>
  import('../../../components/authorised/marketingBlast/groups/groups/GroupsWrapper')
)

const GroupWrap = asyncComponent(() =>
  import('../../../components/authorised/marketingBlast/groups/group/GroupWrap')
)

const PatientListWrap = asyncComponent(() =>
  import('../../../components/authorised/marketingBlast/groups/group/patients/PatientListWrap')
)

const GroupsRoutes = (
  <Switch>
    <Route exact path='/marketing-blast/groups' component={GroupsWrapper} />
    <Route exact path='/marketing-blast/group/:id' component={GroupWrap} />
    <Route exact path='/marketing-blast/group/:id/patients' component={PatientListWrap} />
  </Switch>
)

export default GroupsRoutes;